// E-commerce events for GTM (dataLayer, GA4 format) and Meta Pixel (fbq).
// Both are already loaded by gatsby-ssr.js / gatsby-plugin-google-tagmanager.

const toNumber = (v) => Number(v) || 0;
// sum of line values, rounded to cents (19.95 + 33.92 would otherwise be 53.870000000000005)
const total = (items) => Math.round(items.reduce((s, i) => s + i.price * i.quantity, 0) * 100) / 100;

const pushGtm = (event, ecommerce, extra = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event, ...extra, ecommerce });
};

const pushFbq = (name, params) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", name, params);
  }
};

export const buildItem = ({ id, title, price, quantity = 1 }) => ({
  item_id: id,
  item_name: title,
  price: toNumber(price?.amount),
  quantity,
});

const ecommerce = (items, currency) => ({
  currency: currency || "EUR",
  value: total(items),
  items,
});

const fbParams = (items, currency) => ({
  content_ids: items.map((i) => i.item_id),
  content_type: "product",
  contents: items.map((i) => ({ id: i.item_id, quantity: i.quantity })),
  value: total(items),
  currency: currency || "EUR",
});

export const trackViewItem = (items, currency) => {
  pushGtm("view_item", ecommerce(items, currency));
  pushFbq("ViewContent", fbParams(items, currency));
};

export const trackAddToCart = (items, currency, location) => {
  pushGtm("add_to_cart", ecommerce(items, currency), location ? { cta_location: location } : {});
  pushFbq("AddToCart", fbParams(items, currency));
};

export const trackBeginCheckout = (items, currency) => {
  pushGtm("begin_checkout", ecommerce(items, currency));
  pushFbq("InitiateCheckout", fbParams(items, currency));
};

export const trackViewCart = (items, currency) => {
  pushGtm("view_cart", ecommerce(items, currency));
};

export const trackRemoveFromCart = (items, currency) => {
  pushGtm("remove_from_cart", ecommerce(items, currency));
};
